import { useState } from 'react';
import { useHttp } from './http.hook';

export default function useToken() {
    const {revokeToken} = useHttp();
    
    const getToken = () => {
        const tokenString = localStorage.getItem('token');
        const userToken = tokenString ? JSON.parse(tokenString) : null;
        return userToken;
    };

    const [token, setToken] = useState(getToken());

    const saveToken = (userToken: string) => {
        localStorage.setItem('token', JSON.stringify(userToken));
        setToken(token);
    };

    const deleteToken = () => {
        revokeToken();
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        localStorage.removeItem("iconProfile");
        setToken(null);
        window.location.href = "/";
    }

    return {
        setToken: saveToken,
        deleteToken,
        token
    }
}